module.exports = __webpack_public_path__ + "img/ic_ctb_bell.bdb7b4ff.png";